module.exports = __webpack_public_path__ + "static/media/ev9.2d070152.jpg";